// styling
import styles from "./style.module.scss";
// components
import { NavLink } from "react-router-dom";
import LazyImage from "@components/LazyImage";
import Spring from "@components/Spring";
// hooks
import { useWindowSize } from "react-use";
// assets
import avatar1 from "@assets/uecomix-gifs/OHHHHH.webp";
import { Typography } from "@mui/material";
import React from 'react';
import { Box, Button } from '@mui/material';
import styled from '@emotion/styled';
import andShowTheIdea from '@assets/uecomix-gifs/showing-manga.webp';
import ReactGA from "react-ga4";


const Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#121212',
  borderRadius: '12px',
  padding: '20px',
  color: '#fff',
  maxWidth: '1200px',
  margin: '0 auto',
  position: 'relative',
});

const TextSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

const Heading = styled(Typography)({
  fontSize: '24px',
  marginBottom: '16px',
});

const CustomButton = styled(Button)({
  backgroundColor: '#A020F0',
  fontSize:"1.2rem",
  color: '#fff',
  '&:hover': {
    backgroundColor: '#9321CC',
  },
});

const ImageContainer = styled(Box)({
  border:"2px solid red",
  position: 'relative',
  height: '200px',
  width: '200px',
  borderRadius: '12px',
  overflow: 'hidden',
  marginLeft: '20px',
});

const Image = styled('img')({
  height: '100%',
  width: '100%',
  objectFit: 'cover',
  display: 'block',
});

const GradientOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0))',
  pointerEvents: 'none',
});

const CustomComponent = () => {
  return (
    <Container>
      <TextSection>
        <Heading variant="h4">
          Explore Our Dedicated AI Video Generation Tools
        </Heading>
        <CustomButton variant="contained">
          Create an Account
        </CustomButton>
        <Typography variant="body2" style={{ marginTop: '8px' }}>
          No credit card needed
        </Typography>
      </TextSection>
      <ImageContainer>
      <Spring type="grow">
                <LazyImage
                  src={andShowTheIdea}
                  alt="img"

                />
              </Spring>
        <GradientOverlay />
      </ImageContainer>
    </Container>
  );
};




const CTA2 = () => {
  const { width } = useWindowSize();
  const handleGoogleAnalytics=(type)=>{
    console.log(type)
    ReactGA.event({
      category: 'Account Creation',
      action: 'Click',
      label: type,
  });
  }
  return (
    <section>
      <div>
        <div className={`${styles.wrapper} border-10`}>
          <div className={styles.main}>
            <h4>
              <span className={`${styles.emojis} h3`}>
                <span>🔥</span>
                <span>🔥</span>
                <span>🔥</span>
              </span>
              <span className={styles.ctaHead}>
              Comic Creation Made Easy
              </span>
            </h4>
            <p className={`${styles.main_text} text-light text-light`}>Your Story Starts Here</p>
            <div style={{display:"flex",justifyContent:"center",flexDirection:"column",textAlign:"center"}}>
              <div onClick={()=>handleGoogleAnalytics("Sign Up")}>
              <NavLink
                style={{fontSize:"1.25rem"}}
                className={` btn btn--outline btn--outline-white`}
                to="/signup"
              >
                Create an Account
              </NavLink>
              </div>
              <Typography style={{color:"white",fontWeight:700,marginTop:"0.5rem"}}>No Credit Card Needed</Typography>
            </div>
          </div>

            <div>
              <Spring type="grow">
                <LazyImage
                  src={andShowTheIdea}
                  alt="img"
                  style={{ width: "23rem" }}
                />
              </Spring>
            </div>

        </div>
      </div>
      {/* <CustomComponent/> */}
    </section>
  );
};

export default CTA2;
